<template>
  <div class="basic-block block-banner">
    <div class="banner-wrap">
      <a
        href="/2023_luck"
        class="link"
        @click="link('year-luck')"
      >
        <img src="/static/img/recommend/lp/banner/yearluck2023.png" alt="占うならこちらから" width="320">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockBanner',
  props: {
   lpId: Number,
  },
  data() {
    return {
      gaEvent: {
        yearluck: {
          event_category: `LP6basicresult-choun-banner`,
          // event_label: '',
        },
      },
    }
  },
  methods: {
    link(target) {
      event.preventDefault()
      window.gtag('event', 'click', this.gaEvent[target])
      const href = this.$handoverParams(event.currentTarget.href)
      if (event.currentTarget.target === "_blank") {
        window.open(href, '_blank')
      } else {
        location.href = href
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

.block-banner {
  padding: 40px 0 0;
  background: #fff;
  .link {
    display: table;
    margin: auto;
  }
  img {
    max-width: 100%;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/blocks/BlockBannerYearLuck.vue